
<template>

	<setup_content :title="desc.name + ' модель'" v-if="data && desc">

		<setup_frame title="Описание статистической модели">
			
			<span v-html="data.printable_formula_html[desc.key]"/>

		</setup_frame>

		<b-row class="mt-3">

			<b-col cols="5">

				<b-navbar class="px-0">
					<b-navbar-brand><h4>Агрегированные значения</h4></b-navbar-brand>
				</b-navbar>

				<b-table style="font-size: 10pt;" small :items="aggregation" :fields="aggregation_fields">

					<template v-slot:cell()="_data">

						<span v-if="_data.value == null || _data.value == undefined || _data.value == ''" align="center" style="font-size: 18pt">&infin;</span>
						<span v-else>{{ _data.value }}</span>

					</template>

				</b-table>

			</b-col>

			<b-col>

				<b-navbar class="px-0">
					<b-navbar-brand><h4>Качество статистической модели</h4></b-navbar-brand>
				</b-navbar>

				<b-table style="font-size: 10pt;" small :items="stat" :fields="stat_fields">

					<template v-slot:cell()="_data">

						<div v-if="( _data.value == null || _data.value == undefined || _data.value == '' ) && ( _data.field.key != 'fisher' )" align="center" style="font-size: 18pt">&infin;</div>
						<div v-else>

							<div v-if="_data.field.key == 'set'">

								{{ _data.value }}

							</div>
							<div v-else-if="_data.field.key == 'fisher'">

								<div :style="_data.item.fisher_significance ? '' : 'color: red;'">{{ format_stat(_data.value, false) }}</div>

							</div>
							<div v-else :set="conf_set = _data.item.set == 'Контрольная выборка' ? 'test' : 'teach'">

								<div v-if="data.conf[_data.field.key]">

									<div v-if="_data.field.key == 'determination_coef'" :style="_data.value <= data.conf[_data.field.key][conf_set] ? 'color: red;' : ''">
								
										{{ format_stat(_data.value, false) }}

									</div>
									<div v-else :style="_data.value >= data.conf[_data.field.key][conf_set] * 100 ? 'color: red;' : ''">

										{{ format_stat(_data.value) }}

									</div>

								</div>
								<div v-else>

									{{ format_number(_data.value) }}

								</div>
							</div>

						</div>

					</template>

				</b-table>

			</b-col>

		</b-row>

		<b-navbar class="px-0">
			<b-navbar-brand><h4>Анализ зависимостей</h4></b-navbar-brand>
		</b-navbar>

		<b-table style="font-size: 10pt;" small sort-by="ind" :items="depends" :fields="depends_fields" class="depends mt-2">

			<template #cell(expand)="attr_details">
				<b-button v-if="attr_details.item.attr_type != 'number'" class="filter-button" variant="light" @click="attr_details.toggleDetails">
					<base-icon :name="attr_details.detailsShowing ? 'double_arraow_top' : 'double_arraow_bottom'"/>
				</b-button>
			</template>

			<template v-slot:row-details="data">

				<b-table style="font-size: 10pt;" small sort-by="ind" :items="data.item.values" :fields="values_fields" />

			</template>

		</b-table>

	</setup_content>

</template>

<script>

import api from "../../../../../../api"
import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"

export default
{
	props :
	{
		id : String,
		desc : Object,
		group_id : String,
		data : Object,
	},

	components :
	{
		setup_content,
		setup_frame,
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler(data)
			{
				if(data)
					this.refresh(data)
			}
		}
	},

	data()
	{
		return {

			aggregation : [],
			stat : [],
			depends : [],

			aggregation_fields :
			[
				{ key : "type", label : "Тип", sortable : true },
				{ key : "min", label : "Минимум", sortable : true, tdClass : "text-right" },
				{ key : "max", label : "Максимум", sortable : true, tdClass : "text-right" },
				{ key : "average", label : "Среднее", sortable : true, tdClass : "text-right" },
				{ key : "median", label : "Медианное", sortable : true, tdClass : "text-right" },
			],

			stat_fields :
			[
				{ key : "set", label : "Выборка", sortable : true },
				{ key : "fisher", label : "F-критерий Фишера", sortable : true, tdClass : "text-right" },
				{ key : "determination_coef", label : "Коэффициент детерминации", sortable : true, tdClass : "text-right" },
				{ key : "square_error", label : "Среднеквадратическая ошибка", sortable : true, tdClass : "text-right" },
				{ key : "diff", label : "Сумма невязок", sortable : true, tdClass : "text-right" },
				{ key : "average_error", label : "Средняя ошибка аппроксимации", sortable : true, tdClass : "text-right" },
			],

			values_fields :
			[
				{ key : "attr_value", label : "Значение ЦОФ" },
				{ key : "depend_type", label : "Тип метки" },
				{ key : "value", label : "Метка", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "average_uprs", label : "Среднее значение", tdClass : "text-right" },
			],

		}
	},

	computed :
	{

		depends_fields()
		{
			let fields = [
				{ key : "ind", label : "X", thStyle : "min-width: 60px;" },
				{ key : "name", label : "Ценообразующий фактор", },
				{ key : "type", label : "Тип метки", thStyle : "min-width: 100px;" },
				{
					key : "t",
					label : "t-критерий Стьюдента",
					thStyle : "min-width: 100px;",
					tdClass :
					( t, key, desc ) =>
					{
						if( desc.t_significance )
							return "text-right"
			
						return "text-right bad_cell"
					}
				},
				{ key : "depend_type", label : "Тип зависимости", thStyle : "min-width: 100px;" },
				{ key : "depend_status", label : "Корректность типа зависимости", thStyle : "min-width: 100px;" },
				{ key : "add", label : "Аддитивный коэффициент", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "mul", label : "Мультипликативный коэффициент", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "power", label : "Степень", thStyle : "min-width: 100px;", tdClass : "text-right" },
			]

			if (this.depends.find(attr => attr.attr_type != "number"))
			{
				fields.unshift({ key : "expand", label : "", tdClass : ['expand'] })
			}

			return fields
		}
	},

	methods :
	{
		format_stat(value, percentage = true)
		{
			if(value == null || value == "")
				return ""

			if(percentage)
			{
				const prepared_value = api.round2(Math.abs(value))

				return `${prepared_value} %`
			}

			return api.round2(Math.abs(value))
		},

		format_attr_value(attr, value)
		{
			var __value = value

			if(__value == "true")
				__value = true
			else if(__value == "false")
				__value = false

			return api.format_attr_value(attr, __value)
		},

		format_number(value)
		{
			return api.round2(value)
		},

		refresh(data)
		{
			if(data == null)
				data = this.data

			if(data == null || data.printable_formula_html[this.desc.key] == null)
				return

			var stat_types = [ "fisher_significance" ]
			var stat_teach = { set : "Обучающая выборка" }
			var stat_test = { set : "Контрольная выборка" }

			this.stat_fields.slice(1).forEach(field => stat_types.push(field.key))

			stat_types.forEach(
				stat_type =>
				{
					var stats

					if(this.desc.key != "add" && ( stat_type == "fisher" || stat_type == "fisher_significance" || stat_type == "determination_coef"))
					{
						const key = stat_type == "fisher_significance" ? "fisher_ln_significance" : stat_type + "_ln"

						stats = data.stats[this.desc.key][key]
					}
					else
						stats = data.stats[this.desc.key][stat_type]

					try
					{
						stat_teach[stat_type] = api.round5(stats.teach)
					}
					// eslint-disable-next-line
					catch {}

					try
					{
						if(stat_type != "fisher")
							stat_test[stat_type] = api.round5(stats.test)
					}
					// eslint-disable-next-line
					catch {}
				})

			this.stat = [ stat_test, stat_teach ]

			// #############################################################################

			var aggregation_types = []
			var aggregation = { type : "Скорректированный удельный показатель цены (руб. на единицу измерения)" }
			var aggregation_predicted = { type : "Удельный показатель модельной стоимости" }

			this.aggregation_fields.slice(1).forEach(field => aggregation_types.push(field.key))

			aggregation_types.forEach(
				aggregation_type =>
				{
					try
					{
						aggregation[aggregation_type] = api.round2(data.stats[this.desc.key]["cost_" + aggregation_type].all)
					}
					catch
					{
						aggregation[aggregation_type] = null
					}

					try
					{
						aggregation_predicted[aggregation_type] = api.round2(data.stats[this.desc.key]["predicted_cost_" + aggregation_type].all)
					}
					catch
					{
						aggregation_predicted[aggregation_type] = null
					}

					if(isNaN(aggregation[aggregation_type]))
						aggregation[aggregation_type] = null

					if(isNaN(aggregation_predicted[aggregation_type]))
						aggregation_predicted[aggregation_type] = null
				})

			this.aggregation = [ aggregation_predicted, aggregation ]

			// #############################################################################

			var depends = []
			var promises = []

			data.attrs.forEach(
				attr =>
					promises.push(api.call(this, "cadastral_groups", "get_analogues_statistics", { id : this.group_id, attr : attr.id },
						response =>
						{
							const attr_key = api.attr_key_without_attrs(attr)
							const add_coef = Object.values(data.coefs[this.desc.key]).find(coef => coef.attr_key == attr_key && coef.type == "add")
							const mul_coef = Object.values(data.coefs[this.desc.key]).find(coef => coef.attr_key == attr_key && coef.type == "mul")
							const power_coef = Object.values(data.coefs[this.desc.key]).find(coef => coef.attr_key == attr_key && coef.type == "power")
							const has_stats = data.stats[this.desc.key] != null
							var depend =
								{
									ind : this.data.attrs_indexes[attr.id],
									name : attr.name,
									attr_type : attr.type,
								}

							if(depend.ind != null)
							{
								depend.add = add_coef == null ? 0 : api.round7(add_coef.value)
								depend.mul = mul_coef == null ? 1 : api.round7(mul_coef.value)
								depend.power = power_coef == null ? 1 : api.round7(power_coef.value)
								depend.t = has_stats ? api.round5(data.stats[this.desc.key].t[attr.id]) : null
								depend.t_significance = has_stats ? api.round5(data.stats[this.desc.key].t_significance[attr.id]) : null

								if(response.correlation != null)
									depend.depend_type = response.correlation >= 0 ? "Прямая" : "Обратная"

								if(this.data.depend_status && this.data.depend_status[this.desc.key])
									depend.depend_status = this.data.depend_status[this.desc.key][attr.id] ? "Да" : "Нет"

								if(attr.type == "number")
									depend.type = "Количественная"
								else
								{
									depend.type = "Качественная"
									depend.values = []

									Object.entries(data.params[this.desc.key][attr_key]).forEach(
										elem =>
											depend.values.push(
											{
												attr_value : this.format_attr_value(attr, elem[0]),
												depend_type : elem[1].value >= 0 ? "Прямая" : "Обратная",
												value : elem[1].value,
												average_uprs : api.round2(elem[1].uprs),
											})
										)
								}
							}

							depends.push(depend)
						}))
					)

			Promise.all(promises).then(() => { this.depends = depends })
		},
	}
}

</script>

<style>

.bad_cell
{
	color : red;
}

</style>

<style scoped>
* >>> .depends tbody tr > .expand
{
    padding : 0 !important;
    width: 46px;
}
</style>

